import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import { getItem, setItem, STORAGE_DISCLOSURE_KEY } from '../../utils/local-storage';

const SIX_MONTHS_MS = 6 * 30 * 24 * 60 * 60 * 1000;

interface DisclosureState {
  seen: boolean;
  date: string;
}

function shouldShowBanner(): boolean {
  const stored = getItem<DisclosureState>(STORAGE_DISCLOSURE_KEY);
  if (!stored?.seen) return true;
  if (!stored.date) return true;
  const lastSeen = new Date(stored.date).getTime();
  return Date.now() - lastSeen > SIX_MONTHS_MS;
}

const PrivacyDisclosureBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(shouldShowBanner());
  }, []);

  const handleDismiss = () => {
    setItem(STORAGE_DISCLOSURE_KEY, {
      seen: true,
      date: new Date().toISOString(),
    });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      component="aside"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: 2,
        py: 1,
        bgcolor: 'grey.200',
        borderTop: 1,
        borderColor: 'grey.300',
      }}
      data-testid="privacy-disclosure-banner"
    >
      <Typography variant="body2" sx={{ color: 'grey.700', flex: 1 }}>
        We use local storage to save your cart and improve your visit. See our{' '}
        <Link to="/privacy" style={{ color: '#ff6600', textDecoration: 'underline' }}>
          Privacy policy
        </Link>{' '}
        for details.
      </Typography>
      <IconButton
        size="small"
        onClick={handleDismiss}
        aria-label="Dismiss"
        sx={{ color: 'grey.600' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default PrivacyDisclosureBanner;
